import React, { useState, useEffect, useRef , useContext } from 'react'
import { AddDataBoxImg } from './AddDataBox';
import './Inventory.css'
import Badge from '@mui/material/Badge';
import { Popover, CircularProgress, Button, MenuItem, Autocomplete, TextField } from '@mui/material';
import ChecklistModal from './Modal/ChecklistModal';
import DuplicateModal from './Modal/DuplicateModal';
import ApiService from '../../functions/apiService';
import { toast } from 'react-toastify';
import CustomMenu from './Modal/CustomMenu';
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { Col, Row } from 'react-bootstrap';
import EditMenu from './Modal/EditMenu';
import CreateTicket from './Modal/TicketModal';
import { Link } from "react-router-dom";
import AuthContext from '../../context/AuthContext';
import EntityModal from './Modal/EntityModal';
import ViewEntityModal from './Modal/ViewEntityModal';

const InventoryBox = ({ propdata, loadData , forceExpand , depth = 0}) => {
	const [input, setInput] = useState("");
	const [showInput, setShowInput] = useState(false);
	const [expand, setExpand] = useState(false);
	const [open, setOpen] = useState(false);
	const [value, setValue] = useState('1');
	const [anchorE2, setAnchorE2] = useState(null);
	const openItems = Boolean(anchorE2);
	const id = open ? 'simple-popover' : undefined;
	const [isModalOpen, setModalOpen] = useState(false);
	const [isModalOpen2, setModalOpen2] = useState(false);
	const [quantity, setQuantity] = useState(1);
	const [locationItems, setLocationItems] = useState([]);
	const [assigneeList, setAssigneeList] = useState([]);
	const buttonRef = useRef(null);
	const editButtonRef = useRef(null);
	const [show, setShow] = useState(false);
	const [deletModal, setDeleteModal] = useState(false)
	const [deleteTitle, setDeleteTitle] = useState('')
	const [deleteDesc, setDeleteDesc] = useState('')
	const [isEdit, setIsEdit] = useState(false)
	const [editId, setEditId] = useState('')
	const [editType, setEditType] = useState('')
	const [changeParent, setChangeParent] = useState(false)
	const [parentType, setParentType] = useState("")
	const [parentTypeId, setParentTypeId] = useState("")
	const [parentTypeLocId, setParentTypeLocId] = useState("")
	const [newParentId, setNewParentId] = useState("")
	const [locationDrop, setLocationDrop] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [ticketType, setTicketType] = useState("")
	const [ticketLocId, setTicketLocId] = useState("")
	const [ticketLocName, setTicketLocName] = useState("")
	const [itemLocId, setItemLocId] = useState("")
	const [itemLocName, setItemLocName] = useState("")
	const [successData, setSuccessData] = useState([]);
	const [deleteList, setDeleteList] = useState([]);
	const { permission } = useContext(AuthContext);
	const [entityModal , setEntityModal] = useState(false);
	const [viewEntityModal , setViewEntityModal] = useState(false);
	const handleChange = (event, newValue) => { setValue(newValue); };
	const handleOpenItem = (event) => { setAnchorE2(event.currentTarget); };
	const handleExpandOpen = () => { setExpand(!expand); };
	const handleClose = () => { setOpen(false); };
	const handleCloseEdit = () => { setIsEdit(false); };
	const handleCloseItem = () => { setAnchorE2(null); };
	const handleOpenModal = () => setModalOpen(true);
	const handleCloseModal = () => setModalOpen(false);
	const handleOpenModal2 = () => setModalOpen2(true);
	const handleCloseModal2 = () => setModalOpen2(false);

	const handleOpen = () => {
		if (propdata?.id) {
			setOpen(true);
		}
	};

	const handleOpenEdit = () => {
		if (propdata?.id) {
			setIsEdit(true);
		}
	};

	const handleNewData = () => {
		if (propdata?.id) {
			setOpen(true);
			setShowInput(true);
		}
	}

	useEffect(() => {
		if (propdata?.location_status === null && propdata?.type === null && propdata?.quantity === null) {
			setExpand(true);
		}
	}, [propdata]);

	useEffect(() => {
    if (forceExpand && depth > 1) {
      setExpand(true);
    }
  }, [forceExpand, depth]);

	const handleChecklistSubmit = (data) => {
		ApiService.post('/checklist/add', data).then((data) => {
			if (data.success == true) {
				loadData();
				handleCloseModal();
			}
			toast.success(data.message);
		}).catch((error) => {
			if (error.status == 422) {
				Object.keys(error.data.errors).map((err) => (
					toast.error(error.data.errors[err][0])
				))
			}
			else {
				toast.error(error.data.message)
			}
		})
	};

	const handleDuplicateSubmit = (data) => {
		ApiService.post('/duplicate-inventory', data).then((data) => {
			if (data.success == true) {
				loadData();
				handleCloseModal2();
			}
			toast.success(data.message);
		}).catch((error) => {
			if (error.status == 422) {
				Object.keys(error.data.errors).map((err) => (
					toast.error(error.data.errors[err][0])
				))
			}
			else {
				toast.error(error.data.message)
			}
		})
	};

	const handleInsertNode = (type, shift = false) => {
		if (!input.trim()) {
			toast.error("Please enter data before proceeding")
			return;
		}
		if (value == '2' || value == '3') {
			if (!quantity || quantity < 1) {
				toast.error("Quantity must be at least 1.")
				return;
			}
		}
		const data = {
			"location_id": shift == true ? successData?.id : propdata?.id,
			"type": type,
			"name": input,
			"quantity": quantity,
		};
		ApiService.post('/add-location-and-item', data).then((data) => {
			setInput('');
			toast.success(type == 'item' ? data.data : data.message);
			loadData();
			setExpand(true);
			setSuccessData(data?.data)
		}).catch((e) => {
			if (e && e.status === 422) {
				const errorMsg = e.data?.message || "Validation error occurred.";
				toast.error(errorMsg);
			} else {
				console.error("Unexpected error", e);
				toast.error("An unexpected error occurred.");
			}
		})
	}

	const handleLocationItem = () => {
		ApiService.post('/checklist/location_item', {
			location_id: propdata?.id,
		}).then((data) => {
			setLocationItems(data?.data?.my_items)
		}).catch((error) => {
			toast.error(error);
		})
	}

	const handleChecklistData = () => {
		ApiService.get('/employee-list-inventory',).then((response) => {
			setAssigneeList(response?.data?.data)
		}).catch((error) => {
			toast.error(error);
		})
	}

	const handleChecklistModal = () => {
		handleOpenModal()
		handleLocationItem()
		handleChecklistData()
	}

	const handleDuplicateModal = () => {
		handleOpenModal2()
		handleLocationItem()
		handleChecklistData()
	}

	const deleteItem = () => {
		const body = {
			'id': propdata.id,
		}
		ApiService.post(propdata?.type === 'location' || propdata?.type === 'location_item' ? '/delete-location-and-item' : '/delete-item', body)
			.then((data) => {
				setDeleteModal(false)
				setDeleteList([])
				toast.success(data.data)
				loadData()
			})
			.catch((err) => {
				toast.error(err?.data?.error)
			})
	}

	const updateLocationDrop = (id, type = '') => {
		ApiService.post('/location-details', {
			id: id,
			type: type,
		}).then((data) => {
			var locArr = data?.data.map((loc) => { return { label: loc.location_description, value: loc.id } })
			setLocationDrop(locArr)
		}).catch((error) => {
			toast.error(error?.data?.message);
		})
	}

	const updateParent = () => {
		ApiService.post('/update-parent', {
			type: parentType,
			id: parentTypeId,
			current_parent_id: parentTypeLocId,
			new_parent_id: newParentId
		}).then((data) => {
			loadData();
			setChangeParent(false)
			toast.success(data?.message)
		}).catch((error) => {
			toast.error(error?.data?.message);
		})
	}

	// const printRecursiveData = (location, depth = 0) => {
	//   const indent = '  '.repeat(depth);
	//   // console.log(`${indent}- Location: ${location.location_description}`);
	//   if (Array.isArray(location.items)) {
	//     location.items.forEach((itemObj, idx) => {
	//       const desc = itemObj.item?.item_description ?? "No Description";
	//       // console.log(`${indent}  • Item ${idx + 1}: ${desc}`);
	//     });
	//   }
	//   if (Array.isArray(location.locations)) {
	//     location.locations.forEach(childLoc => {
	//       printRecursiveData(childLoc, depth + 1);
	//     });
	//   }
	// };

	const printRecursiveData = (location) => {
		const tempArr = [];

		const buildData = (loc, depth = 0) => {
			const indent = '  '.repeat(depth);
			tempArr.push({ label: `${indent} • Location: ${loc.location_description}`, indent: indent ? 1 : 0 });

			if (Array.isArray(loc.items)) {
				loc.items.forEach((itemObj, idx) => {
					const desc = itemObj.item?.item_description ?? "No Description";
					tempArr.push({ label: `${indent} ${indent} -> Item: ${desc}`, indent: indent ? 2 : 1 });
				});
			}
			if (Array.isArray(loc.locations)) {
				loc.locations.forEach(childLoc => {
					buildData(childLoc, depth + 1);
				});
			}
		};

		buildData(location);
		setDeleteList(tempArr);
	};

	const deleteDescription = async () => {
		await ApiService.post('/checklist/hirearchy_data', {
			id: propdata?.id,
		})
			.then((data) => {
				printRecursiveData(data?.data)
			})
			.catch((err) => {
				toast.error(err?.data?.error)
			})
	}

	return (
		<>
			<div>
				<div className='inventory-container'>
					<div className='header-container'>
						{propdata?.location_status === null && propdata?.type === null && propdata?.quantity === null ? (
							<>
								<div className='inventory-header' style = {{ paddingLeft:'16px' , paddingRight : '32px' }}>
									<div className='para-header'>
										<img
											className='fire-img'
											src="/images/fire-house.svg"
										/>
										<Badge badgeContent={propdata?.locations?.length + propdata?.items?.length}
											color="success"
											style={{ marginTop: '20px' }}
											sx={{
												'& .MuiBadge-badge': {
													color: '#ffffff',
													fontSize: '12px',
													fontWeight: '700',
												},
											}}>
											<p className='fire-text' style={{ marginRight: '10px' }}>{propdata?.location_description}</p>
										</Badge>
									</div>

									{permission.includes('Inventory_Auth') &&
										<div style={{ marginLeft: '35px', cursor: 'pointer' }}>
											<img
												onClick={handleOpen}
												ref={buttonRef}
												src="/images/add-data.svg"
											/>
										</div>
									}

									<div>
										<CustomMenu
											open={open}
											handleClose={handleClose}
											onClose={handleClose}
											handleChange={handleChange}
											value={value}
											input={input}
											setInput={setInput}
											quantity={quantity}
											setQuantity={setQuantity}
											handleInsertNode={handleInsertNode}
											buttonRef={buttonRef}
											successData={successData}
											expand={expand}
											setExpand={setExpand}
											loadData={loadData}
											propdata={propdata}
										/>
									</div>
								</div>
								

								{(propdata?.locations?.length == 0 && propdata?.items?.length == 0) && (permission.includes('Inventory_Auth')) &&
									<div>
										<Link to="/firehouse/inventory/suggestions">
											<ButtonTheme type='submit' variant="filled" color='primary' className='rounded-2'>
												Inventory Suggestions
											</ButtonTheme>
										</ Link>
									</div>
								}

								<div className='inventory-header-2'>
									{/* {((propdata?.location_status === null && propdata?.type === null && propdata?.quantity === null) 
									&& (propdata?.locations?.length > 0 || propdata?.items?.length > 0) && (permission.includes('Inventory_Auth'))) &&
										<div style={{ marginTop: '-15px', cursor: 'pointer' }} onClick={() => { setShow(true) }}>
											<img
												style={{ width: '25px', height: '25px' }}
												src="/images/rotate_473355.svg"
											/>
										</div>
									} */}
									{/* <Button variant="contained">Refresh Inventory</Button> */}
									<div className='side-header'>
										<img
											src="/images/location-item.svg"
										/>
										<p>Location + Item</p>
									</div>
									<div className='side-header'>
										<img
											src="/images/location.svg"
										/>
										<p>Location</p>
									</div>
									<div className='side-header'>
										<img
											src="/images/item.svg"
										/>
										<p>Item</p>
									</div>
								</div>

							</>
						) :
							<>
								<div style={{ paddingLeft: 10, width: '100%' }}>
									<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '46px' }}>
										<div>
											<div onClick={handleExpandOpen}>
												{propdata?.locations?.length > 0 || propdata?.items?.length > 0 ? (
													expand ? (
														<img
															src="/images/down-arrow.svg"
															style={{
																marginLeft: '-40px',
																marginBottom: '-25px',
																cursor: 'pointer',
															}}
														/>
													) : (
														<img
															src="/images/up-arrow.svg"
															style={{
																marginLeft: '-40px',
																marginBottom: '-25px',
																cursor: 'pointer',
															}}
														/>
													)
												) : (
													<>
														{propdata?.type === 'location' || propdata?.type === 'location_item' ? (
															<img
																src="/images/up-arrow.svg"
																style={{
																	marginLeft: '-40px',
																	marginBottom: '-25px',
																	cursor: 'pointer',
																}}
															/>
														) : (
															<div style={{ marginBottom: '24px' }}></div>
														)}
													</>
												)}
											</div>

											<div style={{ display: 'flex', alignItems: 'center' }}>
												{propdata?.type == 'location' && (
													<img src="/images/location.svg" style={{ marginTop: "-25px" }} />
												)}
												{propdata?.type == 'location_item' && (
													<img src="/images/location-item.svg" style={{ marginTop: "-25px" }} />
												)}
												{propdata?.item?.item_type === null && (
													<img src="/images/location-blue.svg" style={{ marginTop: "-25px" }} />
												)}

												<Badge badgeContent={(propdata?.locations?.length + propdata?.items?.length) || 0} color="success"
													sx={{
														'& .MuiBadge-badge': {
															color: '#ffffff',
															marginTop: '-8px',
															fontSize: '12px',
															fontWeight: '700',
														},
													}}>
													<p
														className="fire-text"
														style={{
															wordWrap: 'break-word',
															fontSize: '16px',
															fontWeight: '500',
															marginTop: '-8px',
															marginRight: '10px',
														}}
													>
														{propdata?.item?.item_description && propdata?.item_quantity
															? `${propdata?.item?.item_description}, Qty: ${propdata?.item_quantity}`
															: propdata?.location_description}
													</p>
												</Badge>

												{propdata?.item?.item_type === null && permission.includes('Inventory_Auth') && (
													<img src="/images/edit-item.png" style={{ marginTop: "-25px", width: '20px', cursor: 'pointer' }}
														ref={editButtonRef}
														onClick={() => {
															handleOpenEdit()
															setEditId(propdata?.item?.id)
															setEditType('item')
														}} />
												)}

												{(permission.includes('Inventory_Auth')) &&
													<div style={{ display: 'flex', gap: '5px', marginTop: '-25px', marginLeft: '30px' }} ref={buttonRef}>
														{propdata?.item?.item_type === null ? '' : (
															<AddDataBoxImg
																className="reply"
																imgSrc="/images/add-data.svg"
																handleClick={handleNewData}
															/>
														)}
													</div>
												}

												{(permission.includes('Inventory_Auth')) &&
													<div>
														{(propdata?.type == 'location' || propdata?.type == 'location_item') && (
															<img src="/images/edit-item.png" style={{ marginTop: "-25px", marginLeft: "10px", width: '20px', cursor: 'pointer' }}
																ref={editButtonRef}
																onClick={() => {
																	handleOpenEdit()
																	setEditId(propdata?.id)
																	setEditType('location_item')
																}} />
														)}
													</div>
												}

												{(permission.includes('Inventory_Auth')) &&
													<div>
														<img src="/images/entity.svg" style={{ marginTop: "-25px", marginLeft: propdata?.type == 'location' || propdata?.type == 'location_item'  ? "10px" : '-20px', width: '20px', cursor: 'pointer' }}
															onClick={() => {
																setViewEntityModal(true)
															}} />
													</div>
												}

												{isEdit &&
													<div>
														<EditMenu
															open={isEdit}
															handleClose={handleCloseEdit}
															onClose={handleCloseEdit}
															value={value}
															input={input}
															setInput={setInput}
															handleInsertNode={handleInsertNode}
															buttonRef={editButtonRef}
															id={editId}
															editType={editType}
															loadData={loadData}
														/>
													</div>
												}
											</div>
										</div>
										<div>
											{(permission.includes('Inventory_Auth')) &&
												<div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginRight: '10px' }}>
													<img src="/images/three-dot-menu.svg" className='m-auto' style={{ cursor: 'pointer' }} onClick={handleOpenItem} />
													<div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginRight: '10px' }}>
														<Popover
															id={id}
															open={openItems}
															anchorEl={anchorE2}
															onClose={handleCloseItem}
															anchorOrigin={{
																vertical: 'bottom',
																horizontal: 'right',
															}}
															slotProps={{
																paper: {
																	sx: {
																		p: 1,
																	},
																},
															}}
														>

															<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}
																onClick={() => {
																	setEntityModal(true)
																	handleCloseItem()
																}}>
																<img src="/images/entity.svg" />
																<p style={{ fontSize: '14px' }}>Manage Entity</p>
															</div>

															{(propdata?.type == 'location' || propdata?.type == 'location_item') &&
																<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}
																	onClick={() => {
																		handleDuplicateModal()
																		handleCloseItem()
																	}}>
																	<img src="/images/approve.svg" />
																	<p style={{ fontSize: '14px' }}>Duplicate Inventory</p>
																</div>
															}

															{(propdata?.type == 'location' || propdata?.type == 'location_item') &&
																<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}
																	onClick={e => {
																		handleChecklistModal()
																		handleCloseItem()
																	}}>
																	<img src="/images/approve.svg" />
																	<p style={{ fontSize: '14px' }}>Create Checklist</p>
																</div>
															}

															<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}
																onClick={() => {
																	setChangeParent(true)
																	setParentType(propdata?.type || 'item')
																	setParentTypeId(propdata?.id)
																	setParentTypeLocId(propdata?.location_parent_id || propdata?.location_id)
																	updateLocationDrop(propdata?.id, propdata?.type == 'location' ? 'location' : propdata?.type == 'location_item' ? 'both' : 'item')
																	handleCloseItem()
																}
																}>
																<img src="/images/location.svg" style={{ height: '20px', width: '20px', marginLeft: '2px' }} />
																<p style={{ fontSize: '14px', marginLeft: '2px' }}>Update Parent</p>
															</div>
															<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}
																onClick={() => {
																	setAddModal(true)
																	setTicketType(propdata?.type ? propdata?.type : 'item')
																	setTicketLocId(propdata?.item?.item_type === null ? propdata?.location_id : propdata?.id)
																	setTicketLocName(propdata?.location_description)
																	setItemLocId(propdata?.id)
																	setItemLocName(propdata?.item?.item_description)
																	handleCloseItem()
																}}
															>
																<img src="/images/ticket.png" style={{ width: '22px' }} />
																<p style={{ fontSize: '14px', marginLeft: '2px' }}>Create Ticket</p>
															</div>

															{(propdata?.type == 'location' || propdata?.type == 'location_item') && (
																<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '14px', padding: '10px', height: '37px' }}
																	onClick={() => {
																		setDeleteModal(true)
																		deleteDescription()
																		// setDeleteDesc("All the sub-locations and items related to this location will be removed.")
																		setDeleteDesc('All the following will be removed-:')
																		{ { propdata?.type == 'location' ? setDeleteTitle(propdata?.location_description) : setDeleteTitle(propdata?.location_description) } }
																		handleCloseItem()
																	}}>
																	<img src="/images/delete-red.png" style={{ width: '18px', height: '18px', marginLeft: '2px' }} />
																	{propdata?.type == 'location' ?
																		<p style={{ fontSize: '14px' }}>Delete Location</p>
																		:
																		<p style={{ fontSize: '14px' }}>Delete Location & Item</p>
																	}
																</div>)}


															{propdata?.item?.item_type === null &&
																<div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '14px', padding: '10px', height: '37px' }}
																	onClick={() => {
																		setDeleteModal(true)
																		setDeleteTitle(propdata?.item?.item_description)
																		setDeleteDesc("Are you sure you want to delete this Item?")
																		handleCloseItem()
																	}}>
																	<img src="/images/delete-red.png" style={{ width: '18px', height: '18px', marginLeft: '2px' }} />
																	<p style={{ fontSize: '14px' }}>Delete Item</p>
																</div>}

															{/* <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'start', gap: '10px', padding: '10px', height: '37px' }}>
																<img src="/images/export-notes.svg" style={{ height: '23px', width: '23px' }} />
																<p style={{ fontSize: '14px' }}>View Items</p>
															</div> */}

														</Popover>
													</div>
												</div>
											}
										</div>
									</div>
								</div>
							</>}
					</div>

					<div style={{ display: expand ? "block" : "none", paddingLeft: '20px', marginLeft: '20px', borderLeft: '1px solid #5362EB' }}>
						{showInput && (
							<div>
								<CustomMenu
									open={open}
									handleClose={handleClose}
									handleChange={handleChange}
									value={value}
									input={input}
									setInput={setInput}
									quantity={quantity}
									setQuantity={setQuantity}
									handleInsertNode={handleInsertNode}
									buttonRef={buttonRef}
									successData={successData}
									expand={expand}
									setExpand={setExpand}
									loadData={loadData}
									propdata={propdata}
								/>
							</div>
						)}

						{[...(propdata?.locations || []), ...(propdata?.items || [])].map((nesData) => (
							<InventoryBox
								key={nesData.id}
								propdata={nesData}
								loadData={loadData}
								forceExpand={expand}
								depth={depth + 1}
							/>
						))}

					</div>
				</div>
				{isModalOpen2 &&
					<div>
						<DuplicateModal
							id={propdata}
							open={isModalOpen2}
							onClose={handleCloseModal2}
							onSubmit={handleDuplicateSubmit}
							locationItem={locationItems}
							assigneeList={assigneeList}
						/>
					</div>
				}
				{isModalOpen &&
					<div>
						<ChecklistModal
							id={propdata}
							open={isModalOpen}
							onClose={handleCloseModal}
							onSubmit={handleChecklistSubmit}
							locationItem={locationItems}
							assigneeList={assigneeList}
						/>
					</div>
				}
				{addModal && <CreateTicket
					id={propdata}
					addModal={addModal}
					ticketType={ticketType}
					ticketLocId={ticketLocId}
					ticketLocName={ticketLocName}
					itemLocId={itemLocId}
					itemLocName={itemLocName}
					setAddModal={setAddModal}
				/>}

				{entityModal && <EntityModal
					data={propdata}
					entityModal={entityModal}
					setEntityModal={setEntityModal}
				/>}

				{viewEntityModal && <ViewEntityModal
					data={propdata}
					viewEntityModal = {viewEntityModal}
					setViewEntityModal = {setViewEntityModal}
				/>}

			</div>


			{/* Delete Modal */}
			<Modal show={deletModal} onHide={() => {
				setDeleteModal(false)
				setDeleteList([])
			}}>
				<Modal.Header closeButton>
					<Modal.Title>{deleteTitle}</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div style={{overflow:'scroll', maxHeight:220}}>
					<div style={{ color: '#555555'}}>
						<div style={{display: 'flex', gap: '10px'}}>
						{deleteDesc} 
						<div className='red-circle-delete'> {deleteList?.length > 0 ? deleteList?.length : ''}</div>
						</div>
						{deleteList.map((line, idx) => (
							<div key={idx} style={{whiteSpace:'pre'}}>
								{line?.indent == 1 && <>&nbsp;</>}
								{line?.indent == 2 && <>&nbsp;&nbsp;</>}
								{line.label}
								</div>
						))}
					</div>
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
								setDeleteModal(false)
								setDeleteList([])
							}}>
								Cancel
							</ButtonTheme>
						</Col>

						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
								onClick={deleteItem}
							>
								Delete
							</ButtonTheme>
						</Col>

					</Row>
				</Modal.Body>
			</Modal>

			{/* Refresh Inventory Modal */}
			{/* <Modal show={show} onHide={() => { setShow(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Refresh Inventory</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						This will remove all your inventories and checklist for this department.
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setShow(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={refreshLocation}>
								Submit
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal> */}

			{/* Parent Change Modal */}
			<Modal show={changeParent} onHide={() => { setChangeParent(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Update Parent</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Do you want to update the parent location ?
					</div>

					<Row>
						<Col md={9}>
							<Autocomplete
								options={locationDrop}
								getOptionLabel={(option) => option.label}
								onChange={(event, newValue) => setNewParentId(newValue?.value || "")}
								renderInput={(params) => (
									<TextField
										{...params}
										className="mt-3 w-75"
										placeholder={propdata?.location_description || propdata?.item?.item_description}
										variant="outlined"
										color="secondary"
										fullWidth
										size="small"
										sx={{
											"& .MuiInputBase-root": {
												height: "48px",
												fontSize: "1rem",
												display: "flex",
												alignItems: "center",
												justifyContent: "center"
											},
											"& .MuiFormLabel-root": {
												marginTop: "4px"
											},
											"& .MuiInputLabel-shrink": {
												marginTop: "0px"
											}
										}} />
								)}
							/>
						</Col>
					</Row>

					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-3' onClick={() => { setChangeParent(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-3' onClick={() => { updateParent() }}>
								Submit
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default InventoryBox;